import { render, staticRenderFns } from "./addBlockAndFieldModal.vue?vue&type=template&id=479cb7e7&scoped=true"
import script from "./addBlockAndFieldModal.vue?vue&type=script&lang=js"
export * from "./addBlockAndFieldModal.vue?vue&type=script&lang=js"
import style0 from "./addBlockAndFieldModal.vue?vue&type=style&index=0&id=479cb7e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479cb7e7",
  null
  
)

export default component.exports